// local hospital domains
export const localHospitalDomains = [
  "https://snjob.moheb.com",
  "https://snjob.mohebmehr.com/",
];
